import { render } from "./Go.vue?vue&type=template&id=9a3ebf6a&scoped=true"
import script from "./Go.vue?vue&type=script&lang=js"
export * from "./Go.vue?vue&type=script&lang=js"

import "./Go.vue?vue&type=style&index=0&id=9a3ebf6a&scoped=true&lang=css"

import exportComponent from "/home/smartphone/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3ebf6a"]])

export default __exports__